import { request } from './common';

const basePath = `${window.configs.API_HOST}/api/lab/admin-portal`;

export async function updateLabOfferImages(offerId: string): Promise<void> {
  await request(`${basePath}/offers/${encodeURIComponent(offerId)}/images/tags`, {
    method: 'POST',
  });
}

export async function updateSingleLabOfferImage(offerId: string, cloudinaryId: string): Promise<void> {
  return await request(
    `${basePath}/offers/${encodeURIComponent(offerId)}/images/${encodeURIComponent(cloudinaryId)}/tags`,
    {
      method: 'POST',
    },
  );
}
